import { UnexpectedEventType } from '@/api/main/types.gen'

export const UNEXPECTED_EVENT_TYPES: ReadonlyArray<UnexpectedEventType> = [
  'unknown',
  'turn_not_possible',
  'road_temporarily_blocked',
  'road_closed',
  'inaccurate_map',
  'inaccurate_gps',
  'custom_event_1',
  'custom_event_2',
  'custom_event_3',
  'custom_event_4',
]
